import { useMutation } from '@tanstack/react-query';
import api from '../../lib/api';

function getDownloadName(contentDisposition?: string) {
  const match = contentDisposition?.match(/filename="?([^"]+)"?/i);

  return match?.[1] || 'carrier-rates.xlsx';
}

export async function downloadCarrierRatesWorkbook() {
  const response = await api.get('/carrier-rates/bulk/export', {
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });

  const fileName = getDownloadName(response.headers['content-disposition']);

  const url = window.URL.createObjectURL(blob);

  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = fileName;

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  window.URL.revokeObjectURL(url);
}

export interface CarrierRateImportResult {
  imported: true;
  created: number;
  updated: number;
  removed: number;
  unchanged: number;
  totalRows: number;
}

export function useImportCarrierRates() {
  return useMutation({
    mutationFn: async (file: File): Promise<CarrierRateImportResult> => {
      const formData = new FormData();

      formData.append('file', file);

      const response = await api.post('/carrier-rates/bulk/import', formData);

      return response.data;
    },
  });
}
